import gql from 'graphql-tag';









const customPaymentCheckoutMutation = gql`
  mutation CustomPaymentCheckout(
    $videoId: String!
    $outputId: String!
    $originUrl: String!
    $paymentType: PaymentType
    $projectMetadata: ProjectMetadataInput
  ) {
    customPaymentCheckout(
      videoId: $videoId
      outputId: $outputId
      originUrl: $originUrl
      paymentType: $paymentType
      projectMetadata: $projectMetadata
    ) {
      orderId
      status
      checkoutUrl
    }
  }
`;

const customPaymentCheckout = () => ({
  mutation: customPaymentCheckoutMutation,
  module: 'payments',
  buildVariables: ({
    videoId,
    outputId,
    originUrl,
    paymentType,
    projectMetadata
  }) => ({
    videoId,
    outputId,
    originUrl,
    paymentType,
    projectMetadata
  })
});

export default customPaymentCheckout;